// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // optional
import { Buffer } from "buffer";

window.Buffer = Buffer;

function checkCryptoSupport() {
  return (
    typeof window !== "undefined" &&
    typeof window.crypto !== "undefined" &&
    typeof window.crypto.subtle !== "undefined"
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!checkCryptoSupport()) {
  root.render(
    <div
      style={{
        color: "#fff",
        backgroundColor: "#000",
        height: "100dvh",
        width: "100vw",
        overflow: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "2rem",
        margin: 0,
        fontFamily: "sans-serif",
      }}
    >
      <img
        src="/images/unlink_splash.png"
        alt="Unlink Logo"
        style={{
          width: "200px",
          marginBottom: "2rem",
          opacity: 0.95,
        }}
      />

      <h2 style={{ margin: "0 0 1rem" }}>Unsupported Browser</h2>
      <p style={{ maxWidth: "400px" }}>
        This app requires secure cryptographic operations via{" "}
        <code>window.crypto.subtle</code>.
      </p>
      <p style={{ maxWidth: "400px" }}>
        Please use a modern browser like <strong>Chrome</strong>,{" "}
        <strong>Firefox</strong>, or <strong>Safari</strong>.
      </p>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}